import styled from 'styled-components';

export const CartEntryTitle = styled.span`
  font-size: 1.1rem;
  font-weight: ${Styles.fontWeight.normal};
  line-height: 1.2;
  padding-right: 2rem;
`;
